import axios from "../../config/axios";
import {
  DASHBOARD_DETAILS_SUCCESS,
  DASHBOARD_DETAILS_FAILED,
  DASHBOARD_DETAILS_INVALID_REQUEST,
  RESET_DASHBOARD_DETAILS,

  DB_FEE_SUCCESS,
  DB_FEE_FAILED,
  DB_FEE_NETWORK_ERROR,
  DB_FEE_RESET
} from "../types";

const resetDashboardDetails = () => {
  return {
    type: RESET_DASHBOARD_DETAILS
  };
};

const getDashboardDetails = userData => dispatch => {
  // dispatch({ type: LOADING });

  axios
    .post("/WalletCustomerService/dashboard", userData)
    .then(res => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(success(res.data));
          break;
        case "2":
          dispatch(failed(res.data));
          break;
        case "3":
          dispatch(invalid_request(res.data));
          break;
        default:
          break;
      }
    })
    .catch(err => err);
};

function failed(data) {
  return {
    type: DASHBOARD_DETAILS_FAILED,
    payload: data
  };
}

function invalid_request(data) {
  return {
    type: DASHBOARD_DETAILS_INVALID_REQUEST,
    payload: data
  };
}

function success(data) {
  return {
    type: DASHBOARD_DETAILS_SUCCESS,
    payload: data
  };
}





const getDashboardFeeDetails = userData => dispatch => {
  // dispatch({ type: LOADING });

  axios
    .post("/WalletCustomerService/feeReport", userData)
    .then(res => {
      switch (res.data.responseCode) {
        case "1":
          dispatch({ type: DB_FEE_SUCCESS, payload: res.data });
          break;
        case "2":
          dispatch({ type: DB_FEE_FAILED, payload: res.data });
          break;
        default:
          dispatch({ type: DB_FEE_FAILED, payload: res.data });
          break;
      }
    })
    .catch(err =>
      dispatch({ type: DB_FEE_NETWORK_ERROR, payload: err })
    );
};


const resetDashboardFeeDetails = () => {
  return {
    type: RESET_DASHBOARD_DETAILS
  };
}

export { resetDashboardDetails, getDashboardDetails, getDashboardFeeDetails, resetDashboardFeeDetails };
